export default __webpack_public_path__ + "static/media/HomeRightIcon.777943cb.svg";